import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"icon-search\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.804 13.423l5.098 5.097a1.015 1.015 0 01-.004 1.44 1.025 1.025 0 01-1.44.003l-5.097-5.097A8.163 8.163 0 012.586 2.647a8.161 8.161 0 0112.218 10.776zm-2.12-.677A6.121 6.121 0 104.029 4.09a6.121 6.121 0 008.657 8.656z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol